import type { Recommendation } from '@shared/dream-components/src';

export async function trackRecommendationImpressions(
  recommendations: Recommendation[],
  subscriberId?: string,
  subscriptionUuid?: string,
): Promise<void> {
  if (!recommendations.length) return;
  if (!subscriberId || !subscriptionUuid) return;

  const slots = recommendations
    .map((r) => ({
      id: r.id,
      description: r.description ?? null,
      impression_token: r.impression_token,
      slot_position: r.slot_position,
    }))
    .filter((r) => r.id && r.impression_token);

  if (!slots.length) return;

  await fetch('/recommendations_impressions', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ slots, subscriber_id: subscriberId, subscription_uuid: subscriptionUuid }),
  });
}
